// Ошибка обмена с сервером, несущая единый конверт. Любой сбой запроса — сетевой обрыв,
// отказ прав, невалидные данные — доезжает до экрана в одной и той же форме, и экран всегда
// может показать причину и следующий шаг (правило 10: блокировка объясняет и предлагает).

import type { ErrorEnvelope } from '@/shared/api/types';

export class ApiError extends Error {
  /** Конверт сервера или синтетический (при обрыве сети). */
  readonly envelope: ErrorEnvelope;
  /** HTTP-статус ответа; null, когда ответа не было вовсе (сеть). */
  readonly status: number | null;

  constructor(envelope: ErrorEnvelope, status: number | null = null) {
    super(envelope.message);
    this.name = 'ApiError';
    this.envelope = envelope;
    this.status = status;
  }

  get code(): string {
    return this.envelope.code;
  }

  /** Сетевой обрыв: ответа не было, повтор осмысленен. */
  get isNetworkError(): boolean {
    return this.status === null;
  }

  static is(error: unknown): error is ApiError {
    return error instanceof ApiError;
  }
}
